import React from 'react';

import Carousel, { carouselData } from './Carousel/Carousel';
import NextSectionButton from '../../components/NextSectionButton/NextSectionButton';
import SliderDots from '../../components/SliderDots/SliderDots';
import useDeviceTypeDetector from '../../hooks/useDeviceTypeDetector';

import { sectionIds } from '../../utils/constants';

import './About.scss';

const AboutSection = ({ activeSlide }) => {
  const { isMobile, isTablet } = useDeviceTypeDetector();

  return (
    <div
      id={sectionIds.about}
      style={{ '--slideCount': `${carouselData.length}` }}
      className={`about-section bg-${Math.min(Math.max(activeSlide, 1), carouselData.length)}`}
    >
      <div className="section-imitator">
        {Array.from(Array(carouselData.length).keys()).map((_) => (
          <section />
        ))}
      </div>
      <div className="content">
        {(isMobile || isTablet) && (
          <SliderDots
            activeIndex={activeSlide - 1}
            count={carouselData.length}
          />
        )}
        <Carousel activeSlide={activeSlide} />
        <NextSectionButton
          title="скачать JiVA"
          sectionId={sectionIds.download}
        />
      </div>
    </div>
  );
};

export default AboutSection;
